import React from 'react';

const SeatReservation = ({ num, data, handleChange }) => {
    return (
        <table
            className='table_style4 bdt mb70'
            cellPadding='0'
            cellSpacing='0'
            id='airCertInfoTbl'
            id-data={num}
        >
            <colgroup>
                <col style={{ width: '190px' }} />
                <col style={{ width: '410px' }} />
                <col style={{ width: '190px' }} />
                <col style={{ width: 'auto' }} />
            </colgroup>
            <tbody>
                <tr>
                    <th>
                        <p className='essential'>항공사 예약번호</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            onChange={(e) => handleChange(num, 'air_pnr', e.target.value.replace(/[\u3131-\u318F\uAC00-\uD7A3]/g, '').toUpperCase())}
                            value={data.air_pnr}
                            style={{ width: '370px' }}
                        />
                    </td>
                    <th>
                        <p class='essential'>승객번호 및 승객명</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            value={data.pax_name}
                            onChange={(e) => handleChange(num, 'pax_name', e.target.value)}
                            style={{ width: '370px' }}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p className='essential'>노선</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            value={data.route}
                            onChange={(e) => handleChange(num, 'route', e.target.value)}
                            style={{ width: '370px' }}
                        />
                    </td>
                    <th>
                        <p class='essential'>요청 좌석</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            value={data.request_seat}
                            onChange={(e) => handleChange(num, 'request_seat', e.target.value)}
                            style={{ width: '370px' }}
                        />
                    </td>
                </tr>
            </tbody>
            <p className='pointText fontWeight'>
                * 위 정보는 모두 기재해 주시기 바랍니다 (*PNR, PNR 상 승객 번호 & 승객 성함, 노선, 요청 좌석 번호*)
            </p>
        </table>
    );
};

export default SeatReservation;
